const translations = {
    errorNotesMax: 'Notes cannot exceed {{charMax}} characters',
    label: 'Notes'
};

export default translations;
